import { IconArrowLeft, IconArrowRight, IconSparkles } from "@tabler/icons-react";
import C1_Image from "../../assets/images/partner/Generous Earnings.svg";
import C2_Image from "../../assets/images/partner/Zero Setup Hassle.svg";
import C3_Image from "../../assets/images/partner/Demonstrable ROI.svg";
import C4_Image from "../../assets/images/partner/Marketing & Sales Materials.svg";
import Slider from "react-slick";
import { useRef } from "react";

const Section5 = () => {

    let sliderRef = useRef(null);
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };

    const settings = {
    dots: false,
    infinite: true,
    centerPadding: "10px",
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    cssEase: "linear",
    responsive: [
        {
            breakpoint: 600,
            settings: {
                slidesToShow : 1,
                slidesToScroll : 1,
                autoplay: true,
                autoplaySpeed: 7000,
                cssEase: "linear"
            }
        }
    ]
    };
  const sliderdata = [
    {
      img: C1_Image,
      t1: "Instant ROI",
      t2: "Automated dispute recovery starts working right away. Clients typically see recovered revenue within the first week and a meaningful boost in margins within the first month."
    },
    {
      img: C2_Image,
      t1: "Hassle-Free Setup",
      t2: "We handle all integrations and evidence gathering (POS, delivery apps, accounting, CCTV). Your clients keep running operations while Voosh works in the background."
    },
    {
      img: C3_Image,
      t1: "Clear Reporting & Co-selling Materials",
      t2: "You and your clients get transparent dashboards on recovered revenue, time saved, and adoption, plus one-pagers, case studies, and pitch decks for effortless positioning."
    },
    {
      img: C4_Image,
      t1: "Human Support When Needed",
      t2: "Your dedicated Voosh partner manager is available for training, deal support and quarterly business reviews. We win together."
    },
  ];

  return (
    <div className="s5-partner f-width m-auto">
        <div className="blur-color-1 rounded-pill"></div>
        <div className="blur-color-2 rounded-pill"></div>
      <p className="s4-h-text text-center">
        <IconSparkles className="color-brand animate__animated animate__bounceIn animate__infinite animate__slower" width="34" height="34" /> Why partners refer Voosh?</p>

      {/* slider cards */}
      <div className="s5-slider slider-container">
        <div style={{ textAlign: "center" }}>
            <button className="btn btn-prev-next rounded-pill" onClick={previous}>
                <IconArrowLeft className="arrow-on-hover" />
            </button>
            <button className="btn btn-prev-next rounded-pill" onClick={next}>
                <IconArrowRight className="arrow-on-hover" />
            </button>
        </div>
        <Slider
        ref={slider => {
          sliderRef = slider;
        }}
        {...settings}
        >
        {sliderdata.map((item, index) => (
          <div key={index} className="s5-slider-card rounded olo-partner-slider-card">
            <img src={item.img} alt={item.t1} />
            <p className="card-t1">{item.t1}</p>
            <p className="card-t2">{item.t2}</p>
          </div>
        ))}
        </Slider>
      </div>
    </div>
  );
};

export default Section5;
